import { createTRPCClient, httpLink } from "@trpc/client";
import type { AppRouter } from "server/types";
import keycloak from "./keycloak";

const serverUrl = process.env.BUN_PUBLIC_SERVER_URL || "http://localhost:3000/rpc";

let currentOrganisationId: string | null = null;

export function setCurrentOrganisationId(id: string | null) {
  currentOrganisationId = id;
}

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    httpLink({
      url: serverUrl,
      async headers() {
        const headers: Record<string, string> = {};
        if (keycloak.authenticated) {
          try {
            await keycloak.updateToken(30);
          } catch {
            keycloak.login();
          }
          headers.Authorization = `Bearer ${keycloak.token}`;
        }
        if (currentOrganisationId) {
          headers["x-organisation-id"] = currentOrganisationId;
        }
        return headers;
      },
    }),
  ],
});
